/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountUserGroupSummary {
    getFixupPrototypeFunction() { return MasterAccountUserGroupSummary.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountUserGroupSummary>): MasterAccountUserGroupSummary {
        let obj = Object.assign(new MasterAccountUserGroupSummary(), model);
        MasterAccountUserGroupSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountUserGroupSummary>): MasterAccountUserGroupSummary {
        if (!model) return null;
        return MasterAccountUserGroupSummary.newInstance(<MasterAccountUserGroupSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountUserGroupSummary) {
        if (!obj) return;

        models.MasterAccountUserGroupSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountUserGroupSummary): boolean {
        Object.setPrototypeOf(obj, MasterAccountUserGroupSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * UserGroup id
     */
    id: string;

    /**
     * Name of UserGroup
     */
    name: string;

}
